import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TDispatchInfoForm, TItemDetailsForm } from '../forms/logistics';
import { TAddress } from '../types/booking';

export type TLogisticsState = {
  details?: {
    dispatchInfo: TDispatchInfoForm;
    itemDetails: TItemDetailsForm;
  };
  addressDetails?: {
    originDetails: TAddress;
    destinationDetails: TAddress;
  };
};

const creatLogisticsSlice = (initialState: TLogisticsState) =>
  createSlice({
    name: 'logisticsBooking',
    initialState,
    reducers: {
      setAddressDetails(
        state,
        { payload }: PayloadAction<Record<'origin' | 'destination', TAddress>>
      ) {
        state.addressDetails = {
          originDetails: payload.origin,
          destinationDetails: payload.destination,
        };
      },

      clearAddressDetails(state) {
        delete state.addressDetails;
      },

      setDetails(
        state,
        {
          payload,
        }: PayloadAction<{
          dispatch: TDispatchInfoForm;
          items: TItemDetailsForm;
        }>
      ) {
        state.details = {
          dispatchInfo: payload.dispatch,
          itemDetails: payload.items,
        };
      },
      clearDetails(state) {
        delete state.details;
      },
    },
  });

const logisticsSlice = creatLogisticsSlice({});

export const {
  setAddressDetails,
  clearAddressDetails,
  clearDetails,
  setDetails,
} = logisticsSlice.actions;
export default logisticsSlice.reducer;
